import BaseService from "./BaseService";
import { RequestDto } from "./dtos/request/RequestDto";
import { TipRequestDto, WithoutTipRequestDto } from "./dtos/request/tipRequestDto";
import { UpdateTipStatusDto } from "./dtos/request/UpdateTipStatusDto";

class TipService extends BaseService {
  private resource = "/tips";

  public pay(
    dto: TipRequestDto,
    postSucess: (data: any) => void,
    postError: (errorMessage: string) => void
  ): void {
    const reqParams = new RequestDto(this.resource + "/pay", dto);
    this.doPost<any>(reqParams, postSucess, postError);
  }

  async withoutTip(
    dto: WithoutTipRequestDto,
    onSuccess: (data: null) => void,
    onError: (errorMessage: string) => void
  ) {
    const reqParams = new RequestDto(this.resource + "/rating/process", dto);
    this.doPost<any>(reqParams, onSuccess, onError);
  }

  async updateStatusTipInProcess(
    dto: UpdateTipStatusDto,
    onSuccess: (data: any) => void,
    onError: (errorMessage: string) => void
  ) {
    const reqParams = new RequestDto(this.resource + "/updateStatusTipInProcess", dto);
    this.doPost<any>(reqParams, onSuccess, onError);
  }
}

export default TipService;
